import { render } from "./Preise.vue?vue&type=template&id=413dd0e7&scoped=true"
import script from "./Preise.vue?vue&type=script&lang=js"
export * from "./Preise.vue?vue&type=script&lang=js"

import "./Preise.vue?vue&type=style&index=0&id=413dd0e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413dd0e7"]])

export default __exports__